const compressedJSON = function (events) {
  let count = 0;
  let dict = {};
  let compressedEvents = [];
  for (let event of events) {
    //compress event name
    if (!(event.e in dict)) {
      dict[event.e] = ++count;
    }

    //compress facets
    let facets = event.d;
    let compressedFacets = {};
    for (let key in facets) {
      if (!(key in dict)) {
        dict[key] = ++count;
      }
      if (!(facets[key] in dict)) {
        dict[facets[key]] = ++count;
      }
      compressedFacets[dict[key]] = dict[facets[key]];
    }

    let tempEvent = Object.assign({}, event);
    tempEvent.e = dict[event.e];
    tempEvent.t = event.t;
    tempEvent.d = compressedFacets;

    compressedEvents.push(tempEvent);
  }
  dict = reverseDict(dict);
  return JSON.stringify({
    dict: dict,
    data: compressedEvents,
  });
};

const reverseDict = function (dict) {
  var ret = {};
  for (var key in dict) {
    ret[dict[key]] = key;
  }
  return ret;
};

export { compressedJSON };
